const CONFIG = {
    AGENT_API_URL: import.meta.env.VITE_AGENT_API_URL,
    BACKEND_API_URL: import.meta.env.VITE_BACKEND_API_URL,
    OATH_CONFIG: {
        authority: import.meta.env.VITE_AUTH_AUTHORITY,
        client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
        redirect_uri: `${window.location.origin}/callback`,
        response_type: "code",
        scope: "email openid profile",
    }
};

export default CONFIG;

console.log("Config Loaded:", CONFIG);